<template>
    <div class="lam-logs uk-flex uk-flex-column">
        <log-item
            v-if="!!shell_record"
            :log="shell_record"
            class="uk-flex-item-none"
        />
        <div class="uk-overflow-container lam-logs-list uk-margin-top uk-flex-item-1">
            <ul v-if="logs.length" class="uk-list uk-list-line">
                <li
                    v-for="log in logs"
                    :key="log.id"
                >
                    <log-item :log="log" />
                </li>
            </ul>
            <div v-else class="uk-text-center"><em class="uk-text-muted">(No log entries)</em></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import orderBy from "lodash/orderBy"

import profile_utilities from "../../../mixins/ProfileUtilities"

import LogItem from "./LogItem"

export default {
    name: "Logs",
    mixins: [profile_utilities],
    components: {
        LogItem
    },
    mounted () {
        this.load()
    },
    watch: {
        $route: "load",
        profile_id: "load"
    },
    methods: {
        load () {
            if(this.profile_id) {
                this.$store.dispatch("FETCH_RECORD_SHELL", {
                    entity: "project_log"
                }).then(record => {
                    record.project_id = this.projectId
                    record.user_id = this.profile_id
                    this.shell_record = record
                }).catch(error => {
                    this.$error(error.message)
                })
            }
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        logs () {
            if(!this.projectId) return []
            return orderBy(this.entity_records("project_log").filter(log => log.project_id === this.projectId), "executed_at", "desc")
        }
    },
    props: {
        projectId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            shell_record: null
        }
    }
}
</script>
